// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var LastName = function (x) {
    return x;
};
var tsBridgeLastName = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("LastName")("__brandLastName"));
    }
};
var writeLastName = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showLastName = Data_Show.showString;
var readLastName = Simple_JSON.readString;
var ordLastName = Data_Ord.ordString;
var newtypeLastName = {
    Coercible0: function () {
        return undefined;
    }
};
var makeLastName = LastName;
var eqLastName = Data_Eq.eqString;
export {
    LastName,
    makeLastName,
    unwrap,
    newtypeLastName,
    eqLastName,
    ordLastName,
    showLastName,
    readLastName,
    writeLastName,
    tsBridgeLastName
};
//# sourceMappingURL=index.js.map
